import { Component, inject, OnInit, OnDestroy } from '@angular/core';
import { AuthService } from '../../services/auth.service';
import { Router, NavigationEnd } from '@angular/router';
import { Subscription, filter } from 'rxjs';
import { GlobalService } from 'src/app/services/global.service';
import { AvailableLanguages } from 'src/assets/i18n/available-languages';

@Component({
  selector: 'app-auth',
  templateUrl: './auth.component.html',
  styleUrls: ['./auth.component.scss'],
})
export class AuthComponent implements OnInit, OnDestroy {
  public _auth = inject(AuthService);
  private router = inject(Router);
  private globalService = inject(GlobalService);

  public isRegisterRoute: boolean = false;
  public availableLanguages = AvailableLanguages;
  public currentLang: string;

  private routerSubscription: Subscription;

  ngOnInit(): void {
    // Initialize current language
    this.currentLang = this.globalService.translate.getActiveLang();

    // Check initial route
    this.isRegisterRoute = this.router.url.includes('/register');

    // Subscribe to route changes
    this.routerSubscription = this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.isRegisterRoute = event.url.includes('/register');
      });
  }

  /**
   * Switch the application language
   * @param lang Language code to switch to
   */
  public switchLanguage(lang: string): void {
    this.globalService.useLanguage(lang);
    this.currentLang = lang;
  }

  ngOnDestroy(): void {
    // Clean up subscription
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe();
    }
  }
}
